import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { RootScopeService } from '../../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../../core/rootscope-declare';
import { Subscription } from 'rxjs';
import { FacilityService } from '../../../../core/services/facility.service';
import { FacilityObject, FacilitySummaryObject } from 'src/app/core/services/facility.model';
import {
  allStaffPermissions,
  staffPermission,
  permissionChanges,
  userPermissions,
  IStaffObject,
} from '../../../services/staff.model';
import { getStaffPermission } from '../../../helpers/staff-permission-data';
import { FeatureFlagsService } from 'src/app/core/shared-service/feature-flags.service';

@Component({
  selector: 'app-staff-permission',
  templateUrl: './staff-permission.component.html',
  styleUrls: ['./staff-permission.component.scss'],
})
export class StaffPermissionComponent implements OnInit, OnChanges {
  rootScopeData: RootScopeDeclare;
  _currentFacility: FacilityObject;
  _staffPermisssion: FacilitySummaryObject;
  private _facilityOnChange: Subscription;
  _allStaffPermissions: allStaffPermissions[];
  _isAdmin: boolean = false;
  _displayParameter: permissionChanges;
  _userRights: userPermissions;
  _viewStaff = false;

  @Input() isAdminChecked: string;
  @Output() onUpdate: EventEmitter<userPermissions> = new EventEmitter();
  @Output() onChangeOfPermission = new EventEmitter();
  @Input() staffInfo: IStaffObject;
  @Input() action: string;
  constructor(private _rootScopeService: RootScopeService, private _facilityService: FacilityService,    
    private featureService: FeatureFlagsService) {}

  getRootScopeData(): void {
    this._rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  ngOnInit(): void {
    this.getRootScopeData();
    this._currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this._currentFacility = res;
    });
    if (this.action === 'view') {
      this._viewStaff = true;
    } else if (this.action === 'add') {
      this.catergorizeStaffPermission();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.isAdminChecked){
      this._isAdmin = changes.isAdminChecked.currentValue.toString() === 'true';
    } if(changes.staffInfo?.currentValue) {
      this.staffInfo = changes.staffInfo.currentValue;
      this.catergorizeStaffPermission();
      this._isAdmin = this.staffInfo?.isAdmin === 'true';
    }
  }

  catergorizeStaffPermission() {
    if (this._currentFacility['summary']) {
      this._staffPermisssion = JSON.parse(JSON.stringify(this._currentFacility.summary));
      this._isAdmin = false;
      if (this.staffInfo) {
        this._allStaffPermissions = getStaffPermission(
          this.featureService,
          this._staffPermisssion,
          true,
          this.staffInfo.userRights,
          this.rootScopeData.currentUser.userId.toString() === this.staffInfo.userId
        );
        this.onEmitUserRights(this.staffInfo.userRights);
      } else {
        this._staffPermisssion.userRights.customLibrary = 'F';
        this._staffPermisssion.userRights.lfodEnabledEquipment = 'F';
        this._userRights = JSON.parse(JSON.stringify(this._staffPermisssion.userRights));
        this._allStaffPermissions = getStaffPermission(
          this.featureService,
          this._staffPermisssion,
          false,
          this._staffPermisssion.userRights,
          false    // allow permission to be changed when in Add page
        );
        this.onEmitUserRights(this._userRights);
      }
    }
  }

  onChange(data: any) {
    this.onChangeOfPermission.emit();
    this._allStaffPermissions[data.position.position1].permission[data.position.position2].type = data.permission.type;
    if (this.staffInfo) {
     this.staffInfo.userRights[data.permission.name] = data.permission.type;
     this.onEmitUserRights(this.staffInfo.userRights);
    } else {
      this._userRights[data.permission.name] = data.permission.type;
      this.onEmitUserRights(this._userRights);
    }
  }
  onEmitUserRights(data: userPermissions) {
    this.onUpdate.emit(data);
  }
  ngOnDestroy() {
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }
}
